module.exports = __webpack_public_path__ + "static/img/szafa_15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_15.jpg
// module id = zIbQ
// module chunks = 0